// extracted by mini-css-extract-plugin
export default {"component":"App_component__uBhCy","page":"App_page__5vKaD"};